export default __webpack_public_path__ + "static/media/londonsky.dd3f0846.jpeg";